export default "__VITE_ASSET__BuLZE0du__"